export const matchingIds = (profileId: string | undefined, myomrUserId: string | undefined) => {
  if (!profileId || !myomrUserId) return false

  return profileId.split('/').pop() === myomrUserId.split('_').pop()
}
